document.addEventListener("DOMContentLoaded", function () {

    var swiper = new Swiper(".engravingSwiper", {
        slidesPerView: 1,
        spaceBetween: 0,
        centeredSlides: true,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        loop: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            // Mobile devices
            320: {
                slidesPerView: 1,
                spaceBetween: 0,
                centeredSlides: true,
            },
            // Tablets
            768: {
                slidesPerView: 1,
                spaceBetween: 10,
                centeredSlides: true,
            },
            // Desktop
            1024: {
                slidesPerView: 1,
                spaceBetween: 20,
                centeredSlides: true,
            }
        }
    });

})